
/* eslint-disable no-console */

// Function to filter arguments
const shouldSuppress = (args) => {
    const message = args.map(arg => String(arg)).join(' ');
    return (
        message.includes('[TikTok]') ||
        message.includes("We're hiring!") ||
        message.includes("Download the React DevTools") ||
        message.includes("Permissions policy violation") ||
        message.includes("accelerometer") ||
        message.includes("devicemotion") ||
        message.includes("already exist") ||
        /^\s*\.+\s*$/.test(message) // Matches ".", " . ", "...", etc.
    );
};

// Override console methods
const methods = ['log', 'info', 'warn', 'debug', 'error', 'dir', 'trace', 'table'];

methods.forEach(method => {
    const original = console[method];
    console[method] = (...args) => {
        if (shouldSuppress(args)) return;
        original(...args);
    };
});
